export default "__VITE_ASSET__fee80c43__"